import PropTypes from "prop-types"
import { useEffect } from "react"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import CartCustomizer from "./components/CartCustomizer"
import FinalProduct from "./components//FinalProduct"

const NotFound = () => {
  useEffect(() => {
    window.location.reload()
  }, [])
  return null
}

const App = (props) => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/cart/design" exact>
          <CartCustomizer {...props} />
        </Route>
        <Route path="/cart/result" exact>
          <FinalProduct {...props} />
        </Route>
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  )
}

App.defaultProps = {
  cart: {
    pre_customized: false,
  },
}

App.propTypes = {
  cart: PropTypes.shape({
    color: PropTypes.string,
    created_at: PropTypes.string,
    id: PropTypes.number,
    image_url: PropTypes.string,
    name: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  path: PropTypes.string.isRequired,
}

export default App
